// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledOverlay from "@tps/App/Components/Common/StyledOverlay";
import XngLoadingOverlayUtilities from "@tps/App/Components/Common/XngLoadingOverlayUtilities";
import { isMobileScreen, isSmallMobileScreen, isTabletScreen, isWideScreen } from "@tps/XDL/Utilities";
import React, { FC, useEffect } from "react";
import { useDispatch } from "react-redux";

const XngUtilities: FC = () => {
    const dispatch = useDispatch();

    const handleResize = () => {
        const isSmallMobile = isSmallMobileScreen();
        const isMobileScreenValue = isMobileScreen();
        const isTabletScreenValue = isTabletScreen();
        const isWideScreenValue = isWideScreen();

        dispatch({ type: "xCommon/update", data: { key: "isSmallMobileScreen", value: isSmallMobile } });
        dispatch({ type: "xCommon/update", data: { key: "isMobileScreen", value: isMobileScreenValue } });
        dispatch({ type: "xCommon/update", data: { key: "isTabletScreen", value: isTabletScreenValue } });
        dispatch({ type: "xCommon/update", data: { key: "isWideScreen", value: isWideScreenValue } });
    };

    useEffect(() => {
        window.addEventListener("resize", handleResize, { passive: true });
        handleResize();

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return (
        <>
            <XngLoadingOverlayUtilities />
        </>
    );
};

export default XngUtilities;
